// Cart service object for centralized management
const AddItemOnTheFlyThroughURL = {
  // Add item to cart with proper error handling
  addItem: function (id, quantity = 1, isVariant = true) {
    const data = {
      items: [
        {
          quantity: quantity,
          id: id,
        },
      ],
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
  },

  // Apply discount code to cart
  applyDiscount: function (discountCode) {
    if (!discountCode) return Promise.resolve();

    return fetch(`/discount/${discountCode}`, {
      method: 'GET',
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Failed to apply discount');
      }
      console.info('Discount applied successfully');
    });
  },

  // Get current cart state
  getCart: function () {
    return fetch('/cart.js').then((response) => response.json());
  },

  // Open cart drawer with animation
  openCartDrawer: function () {
    const $drawer = $('#CartDrawer');

    $drawer.parents('.js').addClass('js-drawer-open lock-scroll');
    $drawer.addClass('is-transitioning').attr('tabindex', '-1');

    setTimeout(() => {
      $drawer.removeClass('is-transitioning').addClass('drawer--is-open');
      document.dispatchEvent(new CustomEvent('cart:build'));
      UrlUtils.removeCartParameters();
    }, 400);
  },
};

// URL utility functions
const UrlUtils = {
  // Get parameter value from URL
  getParameter: function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  // Remove cart-related parameters from URL
  removeCartParameters: function () {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant_id');
    url.searchParams.delete('product_id');
    url.searchParams.delete('discount_code');
    window.history.replaceState({}, document.title, url.href);
  },
};

// Handle auto-add to cart from URL parameters
function handleUrlParameterizedCart() {
  const variantId = UrlUtils.getParameter('variant_id');
  const productId = UrlUtils.getParameter('product_id');
  const discountCode = UrlUtils.getParameter('discount_code');

  let id, isVariant;

  if (variantId) {
    id = variantId;
    isVariant = true;
  } else if (productId) {
    id = productId;
    isVariant = false;
  } else {
    return; // No product specified, exit early
  }

  // Proceed with cart operations if we have a product
  if (id) {
    AddItemOnTheFlyThroughURL.addItem(id, 1, isVariant)
      .then(() => AddItemOnTheFlyThroughURL.applyDiscount(discountCode))
      .then(() => AddItemOnTheFlyThroughURL.openCartDrawer())
      .catch((error) => console.error('Cart operation failed:', error));
  }
}

// Run URL parameter handling after DOM is fully loaded
document.addEventListener('DOMContentLoaded', handleUrlParameterizedCart);

/***
 * Functions for cart management and UI updates
 * created by: Alex
 */
/**
 * Function to remove a free gift item from the cart by setting quantity to zero
 * @param {HTMLElement} element - The element that triggered the function
 * @param {string} productId - The product ID of the gift item to remove
 */
function removeFreeGift(element, productId) {
  // Add loading state to button
  $(element).addClass('btn--loading');

  // Find the line item key for this product in the cart
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function (cart) {
      // Find the line item with the matching product ID
      var lineItemKey = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == productId) {
          lineItemKey = cart.items[i].key;
          break;
        }
      }

      if (lineItemKey) {
        // Use CartJS to update quantity to 0 (remove item)
        CartJS.updateItemById(
          lineItemKey,
          0,
          {},
          {
            success: function (data, textStatus, jqXHR) {
              // Show success message
              showFreeGiftRemovalMessage('Gift removed from cart');

              // Refresh cart drawer content
              document.dispatchEvent(new CustomEvent('cart:build'));

              // Reload page if on cart page
              if (window.location.pathname.includes('/cart')) {
                window.location.reload();
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error('Error removing gift item:', errorThrown);
              $(element).removeClass('btn--loading');
            },
          }
        );
      } else {
        console.error('Could not find the gift item in cart');
        $(element).removeClass('btn--loading');
      }
    },
    error: function (xhr, status, error) {
      console.error('Error getting cart:', error);
      $(element).removeClass('btn--loading');
    },
  });
}




/**
 * Function to show a success message when a gift is removed
 * @param {string} message - The message to display
 */
function showFreeGiftRemovalMessage(message) {
  // Create the message element
  var $messageElement = $('<div class="jsc-free-gift-message"></div>').text(
    message
  );

  // Style the message
  $messageElement.css({
    position: 'fixed',
    top: '20px',
    right: '20px',
    'background-color': '#4caf50',
    color: 'white',
    padding: '15px',
    'border-radius': '4px',
    'z-index': '10000',
    'box-shadow': '0 2px 5px rgba(0,0,0,0.2)',
  });

  // Add to body
  $('body').append($messageElement);

  // Fade out and remove after delay
  setTimeout(function () {
    $messageElement.fadeOut(500, function () {
      $(this).remove();
    });
  }, 3000);
}


/***
 * Functions for cart management and UI updates
 * created by: Priyanka
 */
/**
 * Function to remove a free gift item from the cart by setting quantity to zero
 * @param {HTMLElement} element - The element that triggered the function
 * @param {string} productId - The product ID of the gift item to remove
 */

function showRemoveConfirmationPopup(lineItem, originalButton) {
  // Find the cart__item-details container
  const cartItemDetails = $(originalButton).closest('.cart__item-details');
  
  if (!cartItemDetails.length) {
    console.error('cart__item-details container not found');
    return;
  }

  // Remove any existing popups in this cart item details
  cartItemDetails.find('.remove-confirmation-popup').remove();

  // Create popup HTML
  const popupHTML = `
    <div class="remove-confirmation-popup" data-popup-id="${lineItem.key}">
      <div class="popup-content">
        <div class="popup-body">
          <p>Remove "${lineItem.product_title}"?</p>
          <div class="popup-actions">
            <button class="btn btn-remove" onclick="event.preventDefault(); confirmRemoveProduct('${lineItem.key}', '${originalButton.id || 'remove-btn'}'); return false;">
              Remove
            </button>
            <button class="btn btn-wishlist" onclick="event.preventDefault(); moveToWishlist('${lineItem.variant_id}', '${lineItem.product_id}', '${lineItem.key}', '${originalButton.id || 'remove-btn'}', '${lineItem.product_title.replace(/'/g, "\\'")}', '${lineItem.url || ''}'); return false;">
              Move to Wishlist
            </button>
          </div>
        </div>
        <button class="popup-close" onclick="event.preventDefault(); event.stopPropagation(); closeRemovePopup('${lineItem.key}'); return false;">&times;</button>
      </div>
    </div>
  `;

  // Add popup to cart__item-details
  cartItemDetails.append(popupHTML);
  
  // Show popup with animation
  setTimeout(() => {
    cartItemDetails.find('.remove-confirmation-popup').addClass('show');
  }, 10);
}

function closeRemovePopup(lineItemKey) {
  // Prevent any default behavior that might cause page refresh
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  const popup = $(`.remove-confirmation-popup[data-popup-id="${lineItemKey}"]`);
  popup.removeClass('show');
  setTimeout(() => {
    popup.remove();
  }, 300);
  
  return false;
}

function confirmRemoveProduct(lineItemKey, buttonId) {
  const element = document.getElementById(buttonId) || document.querySelector('[data-product-remove]');
  
  // Add loading state to remove button in popup
  const removeBtn = $(`.remove-confirmation-popup[data-popup-id="${lineItemKey}"] .btn-remove`);
  removeBtn.addClass('btn--loading').text('Removing...');
  
  // Add loading state to original button
  $(element).addClass('btn--loading');

  // Prevent any potential redirects
  event?.preventDefault?.();
  
  // Use CartJS to update quantity to 0 (remove item) - FIXED PARAMETERS
  CartJS.updateItemById(
    lineItemKey,
    0,
    {},  // properties object (required as 3rd parameter)
    {
      success: function () {
        // Refresh cart drawer content without redirect
        document.dispatchEvent(new CustomEvent('cart:build'));
        
        // Close popup after successful removal
        setTimeout(() => {
          closeRemovePopup(lineItemKey);
        }, 1000);
        
        // Remove loading state
        $(element).removeClass('btn--loading');
        removeBtn.removeClass('btn--loading').text('Remove');
        
        // Prevent any redirect attempts
        return false;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error removing product from cart:', errorThrown);
        $(element).removeClass('btn--loading');
        removeBtn.removeClass('btn--loading').text('Remove');
        alert('Error removing product. Please try again.');
        return false;
      }
    }
  );
  
  // Prevent any default behavior
  return false;
}

function moveToWishlist(variantId, productId, lineItemKey, buttonId, productTitle, productUrl) {
  const element = document.getElementById(buttonId) || document.querySelector('[data-product-remove]');
  
  // Add loading state to wishlist button in popup
  const wishlistBtn = $(`.remove-confirmation-popup[data-popup-id="${lineItemKey}"] .btn-wishlist`);
  wishlistBtn.addClass('btn--loading').text('Adding...');
  
  // Add loading state to original button
  $(element).addClass('btn--loading');

  // Prevent any potential redirects
  event?.preventDefault?.();

  // Debug Swym availability
  console.log('Checking Swym availability...');
  console.log('window.swat:', window.swat);

  // Check multiple possible Swym objects
  let swymInstance = null;
  if (window.swat) {
    swymInstance = window.swat;
    console.log('Using window.swat');
  } else if (window.Swym) {
    swymInstance = window.Swym;
    console.log('Using window.Swym');
  } else if (window._swat) {
    swymInstance = window._swat;
    console.log('Using window._swat');
  }

  if (!swymInstance) {
    console.error('Swym wishlist is not available. Checked: window.swat, window.Swym, window._swat');
    wishlistBtn.removeClass('btn--loading').text('Move to Wishlist');
    $(element).removeClass('btn--loading');
    alert('Wishlist feature is currently unavailable. Please try again later.');
    return false;
  }

  // Create proper full URL for Swym (fix the URL validation error)
  let fullProductUrl;
  if (productUrl && productUrl.startsWith('http')) {
    fullProductUrl = productUrl;
  } else if (productUrl && productUrl.startsWith('/')) {
    fullProductUrl = window.location.origin + productUrl;
  } else {
    // Create URL from product title if no URL provided
    const handle = productTitle.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single
      .trim();
    fullProductUrl = `${window.location.origin}/products/${handle}`;
  }

  // Prepare product object for Swym with proper URL format
  const product = {
    epi: variantId,
    empi: productId,
    du: fullProductUrl
  };

  console.log('Adding to wishlist with product:', product);

  // Step 1: First fetch the wishlists to get the correct list ID
  swymInstance.fetchLists({
    callbackFn: function(wishlists) {
      console.log('Fetched wishlists:', wishlists);
      
      // Find the target list ID
      let targetListId = null;
      
      if (wishlists && wishlists.length > 0) {
        // Try to find default list or use first available
        const defaultList = wishlists.find(list => 
          list.lname === 'default' || 
          list.lname === 'wishlist' || 
          list.isDefault === true
        );
        targetListId = defaultList ? defaultList.lid : wishlists[0].lid;
        
        console.log('Using list ID:', targetListId, 'from list:', defaultList || wishlists[0]);
        
        // Step 2: Add product to the specific list
        swymInstance.addToList(
          targetListId,
          product,
          function(response) {
            console.log('Successfully added to wishlist with list ID:', targetListId, response);
            removeFromCartAfterWishlist(lineItemKey, element, wishlistBtn);
          },
          function(error) {
            console.error('Error adding product to list:', error);
            handleWishlistError(lineItemKey, element, wishlistBtn);
          }
        );
      } else {
        // No wishlists found, try with default string
        console.log('No wishlists found, trying with default list ID');
        swymInstance.addToList(
          'default',
          product,
          function(response) {
            console.log('Successfully added to default wishlist:', response);
            removeFromCartAfterWishlist(lineItemKey, element, wishlistBtn);
          },
          function(error) {
            console.error('Error adding to default list:', error);
            handleWishlistError(lineItemKey, element, wishlistBtn);
          }
        );
      }
    },
    errorFn: function(error) {
      console.error('Error fetching wishlists:', error);
      
      // Fallback: try with default list ID if fetchLists fails
      console.log('Fallback: trying addToList with default');
      swymInstance.addToList(
        'default',
        product,
        function(response) {
          console.log('Fallback successful - added to default wishlist:', response);
          removeFromCartAfterWishlist(lineItemKey, element, wishlistBtn);
        },
        function(error) {
          console.error('Fallback also failed:', error);
          handleWishlistError(lineItemKey, element, wishlistBtn);
        }
      );
    }
  });
  
  return false;
}

function removeFromCartAfterWishlist(lineItemKey, element, wishlistBtn) {
  CartJS.updateItemById(
    lineItemKey,
    0,
    {},  // properties object (required as 3rd parameter)
    {
      success: function () {
        showFreeGiftRemovalMessage('Product moved to wishlist and removed from cart');
        document.dispatchEvent(new CustomEvent('cart:build'));
        
        // Close popup after successful operation
        setTimeout(() => {
          closeRemovePopup(lineItemKey);
        }, 1000);
        
        // Remove loading states
        $(element).removeClass('btn--loading');
        wishlistBtn.removeClass('btn--loading').text('Move to Wishlist');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error removing product from cart after adding to wishlist:', errorThrown);
        $(element).removeClass('btn--loading');
        wishlistBtn.removeClass('btn--loading').text('Move to Wishlist');
        alert('Added to wishlist but failed to remove from cart. Please remove manually.');
      }
    }
  );
}

function handleWishlistError(lineItemKey, element, wishlistBtn) {
  // Remove loading states
  $(element).removeClass('btn--loading');
  wishlistBtn.removeClass('btn--loading').text('Move to Wishlist');
  
  alert('Could not add to wishlist. Please try again.');
}

function removeProductFromCart(element, productId) {
  // Check if the clicked element is a button
  const isButton = element.tagName.toLowerCase() === 'button' || $(element).is('button');

    // Only add loading class if it's not a button
    if (!isButton) { $(element).addClass('btn--loading');}
    else{
      console.log('qty__wrapperqty__wrapperqty__wrapperqty__wrapper'); 
      $(element).closest('.js-qty__wrapper').addClass('is-loading');
    }
  // Get the cart container to check non-free-gift count
  const cartContainer = $(element).closest('.cart__items');
  const nonFreeGiftCount = parseInt(cartContainer.data('non-free-gift-size')) || 0;
  
  // Fetch cart data
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function (cart) {
      
      const lineItem = cart.items.find(item => item.id === Number(productId));
      if (!lineItem) {
        console.error(`Product ID ${productId} not found in bag`);
        if (!isButton) {$(element).removeClass('btn--loading');}
        else{$(element).closest('.js-qty__wrapper').removeClass('is-loading');}
        return;
      }    
      
      // Check if this is the last non-free-gift item
      if (nonFreeGiftCount === lineItem.quantity) {
        if (!isButton) {
          $(element).removeClass('btn--loading');
        }
        else{$(element).closest('.js-qty__wrapper').removeClass('is-loading');}
        showRemoveConfirmationPopup(lineItem, element);
      } else {
        // Directly remove the product
        const lineItemKey = lineItem.key;
        CartJS.updateItemById(
          lineItemKey,
          0,
          {},
          {
            success: function (data, textStatus, jqXHR) {
              // Re-render the cart in place (theme.CartForm listens for 'cart:build')
              // instead of a full page reload — smooth, like the drawer.
              document.dispatchEvent(new CustomEvent('cart:build'));
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error('Error removing product:', errorThrown);
              if (!isButton) {
                $(element).removeClass('btn--loading');
              }
              else{$(element).closest('.js-qty__wrapper').removeClass('is-loading');}
            },
          }
        );
      }
    },
    error: function (xhr, status, error) {
      console.error('Error fetching cart:', error);
      if (!isButton) {
        $(element).removeClass('btn--loading');
      }
      else{$(element).closest('.js-qty__wrapper').removeClass('is-loading');}
    }
  });
}

/**
 * Function to add an item to the cart
 * * @param {string} id - The product ID to add
 */
function addToCartProduct(e) {
  var $this = $(e);
  var $siblingThis = $this.siblings('.jsc-data-var-atb');
  var $varID = $siblingThis.attr('data-var-id');

  // Pass the button element to addToCart
  // The drawer opening logic has been moved into the success callback of addToCart
  addToCartItem($varID, 1, {}, $this);
}

/**
 * Function * to add an item to the cart
 * @param {string} id - The product ID to add
 * @param {number} quantity - The quantity to add
 * @param {object} obj - Additional properties to add with the item
 * @param {HTMLElement} buttonElement - The button element that triggered the function
 */
function addToCartItem(vid, qty, obj, buttonElement) {
  const $button = $(buttonElement);
  $button.addClass('btn--loading');

  if (theme.settings.cartOptimization) {
    document.dispatchEvent(new CustomEvent('cart:adding'));
  }

  // Use theme's existing cart add method
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify({
      id: vid,
      quantity: qty,
      properties: obj || {},
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => response.json())
    .then(function (data) {
      $button.removeClass('btn--loading');

      // Trigger cart update
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: buttonElement,
          },
        })
      );

      // If on cart page, reload
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      }
    })
    .catch(function (error) {
      $button.removeClass('btn--loading');
      console.error('Error:', error);
    });
}

/**
 * Shared add-to-cart used by both the grid quick-add icon and the quick view
 * modal, so both behave identically (optimistic drawer open via 'cart:adding',
 * then 'ajaxProduct:added' to build the cart).
 *
 * @param {number|string} variantId
 * @param {number} quantity
 * @param {HTMLElement} [btnEl] - optional button to toggle an is-loading state on
 * @returns {Promise}
 */
window.PCAddToCart = function(variantId, quantity, btnEl) {
  if (btnEl) btnEl.classList.add('is-loading');

  // Optimistically open the cart drawer right away (when enabled)
  if (theme.settings.cartOptimization) {
    document.dispatchEvent(new CustomEvent('cart:adding'));
  }

  return fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify({
      id: variantId,
      quantity: quantity || 1
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(function(response) { return response.json(); })
  .then(function(data) {
    if (btnEl) btnEl.classList.remove('is-loading');
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: data,
        addToCartBtn: btnEl
      }
    }));
    return data;
  })
  .catch(function(error) {
    if (btnEl) btnEl.classList.remove('is-loading');
    console.error('Error:', error);
    throw error;
  });
};

/**
 * Quick Add to Cart - product icon button on product grid images
 */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.pc-quick-atc-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  if (btn.classList.contains('is-loading')) return;

  // Multi-variant products: open the quick view modal so the shopper can pick a
  // variant (e.g. 15ml vs 150ml). Only when quick view is enabled (asset loaded).
  // When disabled, fall through to the normal direct add (first available variant
  // + open drawer), same as the single-variant button.
  var variantCount = parseInt(btn.getAttribute('data-variant-count') || '1', 10);
  if (variantCount > 1 && window.PCQuickView) {
    var handleEl = btn.closest('[data-product-handle]');
    var handle = btn.getAttribute('data-product-handle') || (handleEl ? handleEl.getAttribute('data-product-handle') : null);
    if (handle) {
      var hiddenAttr = btn.getAttribute('data-hidden-variants') || '';
      var hiddenIds = hiddenAttr.split(',').filter(Boolean);
      window.PCQuickView.open(handle, { hiddenVariantIds: hiddenIds });
      return;
    }
  }

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  window.PCAddToCart(variantId, 1, btn);
});

/**
 * Cart page: rebuild the item list after ANY successful add-to-cart — in ONE place.
 * There are two add paths (single-variant direct add via PCAddToCart, and multi-variant
 * via the quick-view modal), but both ultimately `POST /cart/add.js`. So instead of
 * hooking each path, we watch that one shared request and fire `cart:build` once
 * (theme.CartForm re-renders items + subtotal via AJAX — no reload, like the drawer).
 * Covers any current or future add path automatically.
 */
(function () {
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    return origFetch.apply(this, arguments).then(function (res) {
      if (res && res.ok && /\/cart\/add(\.js)?(\?|$)/.test(url) &&
          document.body && document.body.classList.contains('template-cart')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      return res;
    });
  };
})();
